import { render, staticRenderFns } from "./DrawerContent.vue?vue&type=template&id=33c2f2d3"
import script from "./DrawerContent.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerContent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports